import { Divider as MuiDivider, DividerProps as MuiDividerProps } from '@mui/material';

interface DividerProps extends MuiDividerProps {
  sx?: any;
}

export const Divider = (props: DividerProps) => (<MuiDivider sx={{ ...props.sx }} {...props} />);
